<template>
  <el-scrollbar>
    <div class="scrollbar-flex-content">
      <CTable>
        <CTableHead>
          <tr class="d-flex" :class="`nest${info.part_item_id}`">
            <CTableHeaderCell :style="info.extension_info.cols.length <= 4 ? 'flex:1' : 'width:200px'">
              <CButton
                class="btn-outline-primary text-light"
                v-if="!showChild"
                @click="showChild = !showChild"
              >
                <img src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
              <CButton
                class="btn-outline-primary text-light"
                v-else
                @click="showChild = !showChild"
              >
                <img class="openImg" src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
            </CTableHeaderCell>
            <CTableHeaderCell
            :class="showChild ? '' : 'd-none'"
              v-for="(col, index) in info.extension_info.cols"
              :key="index"
              :style="info.extension_info.cols.length <= 4 ? 'flex:1' : 'width:200px'"
              style="white-space:normal;"
            >
            <div class="d-flex justify-content-center">
              {{ col.title }}
            </div>
            </CTableHeaderCell>
          </tr>
        </CTableHead>
        <CTableBody :class="showChild ? '' : 'd-none'">
          <tr class="d-flex" :class="`nest${info.part_item_id}`" v-for="(row, index) in info.extension_info.rows" :key="index">
            <CTableHeaderCell style="white-space:normal;" :style="info.extension_info.cols.length <= 4 ? 'flex:1' : 'width:200px'"> {{ row.title }} </CTableHeaderCell>
            <CTableDataCell
            :style="info.extension_info.cols.length <= 4 ? 'flex:1' : 'width:200px'"
              v-for="(col, col_index) in info.extension_info.cols"
              :key="col_index"
            >
            <div class="d-flex justify-content-center">
              <CFormCheck
                type="radio"
                :disabled="+info.is_help"
                :id="String(`nest${info.part_item_id}${index}`)"
                :name="String(`nest${info.part_item_id}${index}index`)"
                :value="col"
                :checked="
                  info.value_info
                    ? col_index === info.value_info[index]
                    : col_index === answerList[index]
                "
                @change="emitContent(index, col_index, index)"
              />
            </div>
            </CTableDataCell>
          </tr>
        </CTableBody>
      </CTable>
    </div>
  </el-scrollbar>
</template>

<script>
import { ref, onMounted, watch, computed } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content', 'isOpen'],
  setup(props, { emit }) {
    const answerIndex = ref('')
    const showChild = ref(true)
    const answerList = ref([])
    onMounted(() => {
      // const tr = document.querySelectorAll(`.nest${props.info.part_item_id}`)
      // if(tr){
      //   const trWidth = props.info.extension_info.cols.length * 250 + 'px';
      //   tr.forEach(e=>{
      //     e.style.width = trWidth
      //   })
      // }
      for (let i = 0; i < props.info.extension_info.rows.length; i++) {
        answerList.value.push(null)
      }
      emitContent()
    })
    const isFinish = computed(()=>{
      let state = []
      answerList.value.forEach(e=>{
        state.push(e !== null)
      })
      return state.find(e=>e === false) === undefined
    })
    const emitContent = (e, colIndex, rowIndex) => {
      answerList.value[rowIndex] = colIndex
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: isFinish.value,
        value_info: +props.info.is_help === 0 ? [...answerList.value] : [],
      })
    }
    watch(
      () => props.info.value_info,
      () => {
        for (let i = 0; i < props.info.value_info.length; i++) {
          answerList.value[i] = props.info.value_info[i]
        }
        emitContent()
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
      {immediate: true, deep: true}
    )
    return {
      emitContent,
      answerIndex,
      showChild,
      answerList,
    }
  },
}
</script>
<style lang="scss" scoped>
.openImg {
  rotate: (180deg);
}
</style>
